module.exports = __webpack_public_path__ + "img/header-engagementRingsClassic.4534029.webp";